import { render, staticRenderFns } from "./ForgeFileViewer.vue?vue&type=template&id=c0a96d7a&scoped=true"
import script from "./ForgeFileViewer.vue?vue&type=script&lang=js"
export * from "./ForgeFileViewer.vue?vue&type=script&lang=js"
import style0 from "./ForgeFileViewer.vue?vue&type=style&index=0&id=c0a96d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a96d7a",
  null
  
)

export default component.exports